import React, { useState } from 'react';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { Button } from '@progress/kendo-react-buttons';
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";
import Notifications from '../components/Notifications';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { NumericTextBox } from '@progress/kendo-react-inputs';
import ExpansionPanel from "../components/ExpansionPanel";

const Inventory = () => {
    const [columns, setColumns] = React.useState(null);
    const [spColumns, setSpColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [dialogTitle, setDialogTitle] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const [sourceStockpiles, setSourceStockpiles] = React.useState([]);
    const [sourceDestpiles, setDestStockpiles] = React.useState([]);
    const [stockpiles, setStockpiles] = React.useState([]);
    const [products, setProducts] = React.useState([]);
    const [sourceProduct, setSourceProduct] = React.useState();
    const [destProduct, setDestProduct] = React.useState();
    const [source, setSource] = React.useState("");
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState(GetSession().SiteID);
    const [dest, setDest] = React.useState("");
    const [operation, setOperation] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [amount, setAmount] = React.useState(0);
    const [update, setUpdate] = React.useState();
    const [showStockpile, setShowStockpile] = React.useState(false);
    const [expandedPanels, setExpandedPanels] = useState({
        manageInventory: true,
        manageStockpiles: false
    });

    const togglePanel = (panel) => {
        setExpandedPanels(prev => ({ ...prev, [panel]: !prev[panel] }));
    };
    const [layout, setLayout] = React.useState([
        { "field": "manageInventory", "label": "Manage Inventory", "defaultValue": "", "isVisible": true, "type": "tab" },
        { "field": "manageStockpiles", "label": "Manage Stockpiles", "defaultValue": "", "isVisible": true, "type": "tab" },
        { "field": "site", "label": "Site", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "add", "label": "Add", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "deduct", "label": "Deduct", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "stocktake", "label": "Stocktake", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "history", "label": "History", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "convertProduct", "label": "Convert Product", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "move", "label": "Move", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "product", "label": "Product", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "stockpile", "label": "Stockpile", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "amount", "label": "Amount", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "destinationStockpile", "label": "Destination Stockpile", "defaultValue": "", "isVisible": true, "type": "button" },
        { "field": "convertedProduct", "label": "Converted Product", "defaultValue": "", "isVisible": true, "type": "button" },

    ]);
    const stockSubTotals = [
        { field: 'stockLevel', aggregate: 'sum' },
        { field: 'stockValue', aggregate: 'sum' }
    ];
    const navigate = useNavigate();
    if (localStorage.getItem("userid") === null) navigate("/logout");
    if (permissions && !permissions.CanView) navigate("/error401");
    React.useEffect(() => {
        GetColumnDefs("InventoryMovements", setColumns);
        GetColumnDefs("Stockpile", setSpColumns);
        GetPermissions(["ViewInventory", "ManageInventory", "ReportInventory"], setPermissions);
        var url = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'Inventory'";
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => response.json()).then(d => {
            if (GetSession().IsMobile) {
                let data = [];
                for (let i = 0; i < d.length; i++) {
                    data.push({ field: d[i].field, label: d[i].label, type: d[i].type, format: d[i].format, isVisible: d[i].isVisible && d[i].isVisibleOnMobile });
                }
                setLayout(data);
            } else {
                setLayout(d);
            }
        });
        url = configData.SERVER_URL + "apiv7/options";
        fetch(url, init).then(response => response.json()).then(d => {
            setSites(d.sites);
            setProducts(d.products);
            setStockpiles(d.stockpiles);
            setSourceStockpiles(d.sourceStockpiles);
            setDestStockpiles(d.destStockpiles);
        });
    }, [])

    const GetField = (f) => {
        return layout.find(obj => { return obj.field === f });
    }

    const AddInventory = () => {
        InitDialog("Add to Inventory", "INVAdd");
    }

    const DeductInventory = () => {
        InitDialog("Remove from Inventory", "INVDeduct");
    }

    const StockTakeInventory = () => {
        InitDialog("Change inventory level", "INVStocktake");
    }

    const UpdateInventory = (operation) => {
        var url = `${configData.SERVER_URL}apiv7/inventorymovements`;
        let type = "IN";
        let docketNo = "MANUAL";
        let amt = amount;
        var utcDate = new Date().toISOString();
        switch (operation) {
            case "Deduct":
                type = "OUT";
                amt = -amt;
                break;
            case "Stocktake":
                docketNo = "STOCK TAKE";
                break;
            default:
                type = "IN";
                break;
        }
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "dateCreated": utcDate,
                "productId": sourceProduct.id,
                "product": null,
                "type": type,
                "amount": amt,
                "userId": 1,
                "user": null,
                "siteId": site,
                "site": null,
                "isEdit": false,
                "isZeroed": false,
                "dateZeroed": null,
                "docketNo": docketNo,
                "zeroedBy": 0,
                "isActive": true,
                "stockLevel": 0,
                "stockValue": 0
            })
        }
        fetch(url, init).then(response => {
            setUpdate(new Date());
            if (response.ok) setMessage("Inventory updated");
        });
    }

    const AddStockpile = () => {
        InitDialog("Add to Stockpile", "Add");
    }

    const DeductStockpile = () => {
        InitDialog("Remove from stockpile", "Deduct");
    }

    const Stocktake = () => {
        InitDialog("Change stock level", "Stocktake");
    }

    const MoveStockpile = () => {
        InitDialog("Move stockpile", "Move");
    }

    const ConvertProduct = () => {
        InitDialog("Convert product", "Convert");
    }

    const InitDialog = (title, op) => {
        if (op.indexOf("INV") === 0 && site === 1) {
            alert("Please select a site");
            return;
        }
        setMessage("");
        setShowStockpile(op.indexOf("INV") !== 0);
        setOperation(op);
        setSource("");
        setSourceProduct();
        setDest("");
        setDestProduct();
        setAmount(0);
        setDialogTitle(title);
    }

    const DialogNo = () => {
        setDialogTitle("");
    }

    const DialogOk = () => {
        if (showStockpile && source === "") {
            alert("Please select a stockpile");
            return;
        }
        if (sourceProduct === undefined) {
            alert("Please select a product");
            return;
        }
        if (amount === 0) {
            alert("Please enter an amount");
            return;
        }
        if ((operation === "Move" || "operation" === "Convert") && dest === "") {
            alert("Please select a destination stockpile");
            return;
        }
        if (operation === "Convert" && destProduct === undefined) {
            alert("Please select a converted product");
            return;
        }
        setDialogTitle("");
        if (showStockpile) {
            UpdateStockpile(operation);
        } else {
            UpdateInventory(operation.substring(3));
        }
    }

    const UpdateStockpile = (operation) => {
        var url = configData.SERVER_URL + `apiv7/stockpiles`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "site": site,
                "operation": operation,
                "source": source,
                "sourceProduct": sourceProduct.id,
                "amount": amount,
                "dest": dest,
                "destProduct": operation == "Convert" ? destProduct.id : null
            })
        }
        fetch(url, init).then(response => {
            setUpdate(new Date());
            if (response.ok) setMessage("Stockpile updated");
        });
    }

    const sourceChanged = (e) => { setSource(e.value) }
    const destChanged = (e) => { setDest(e.value) }
    const amountChanged = (e) => { setAmount(e.value) }
    const sourceProductChanged = (e) => { setSourceProduct(e.value) }
    const destProductChanged = (e) => { setDestProduct(e.value) }
    const siteChanged = (e) => { setSite(e.value.id) }

    return (
        <div style={{ padding: 20, maxWidth: 1200, margin: "auto" }}>
            <Notifications errorMessage={errorMessage} />
            {GetField("manageInventory")["isVisible"] && <ExpansionPanel title={GetField("manageInventory")["label"]} expanded={expandedPanels.manageInventory} onToggle={() => togglePanel("manageInventory")}>
                    <div className="row" style={{ padding: "5px 10px" }}>
                        <div className="col-md-8" style={{ color: "red" }}>{message}</div>
                    </div>
                    {GetSession().SiteID === 1 && GetField("site")["isVisible"] && <div className="row" style={{ padding: "5px 10px" }}>
                        <div className="col-md-1">
                            <label className="control-label">{GetField("site")["label"]}</label>
                        </div>
                        <div className="col-md-3">
                            <DropDownList data={sites} onChange={siteChanged} textField="name" />
                        </div>
                    </div>}

                    {permissions && permissions.ManageInventory && <div className="row" style={{ padding: "5px 10px" }}>
                        {GetField("add")["isVisible"] && <div className="col-md-2">
                            <Button themeColor={"primary"} onClick={AddInventory}>{GetField("add")["label"]}</Button>
                        </div>}
                        {GetField("deduct")["isVisible"] && <div className="col-md-2">
                            <Button themeColor={"primary"} onClick={DeductInventory}>{GetField("deduct")["label"]}</Button>
                        </div>}
                        {GetField("stocktake")["isVisible"] && <div className="col-md-2">
                            <Button themeColor={"primary"} onClick={StockTakeInventory}>{GetField("stocktake")["label"]}</Button>
                        </div>}
                        {GetField("history")["isVisible"] && <div className="col-md-2">
                            <a href="InventoryHistory"><Button themeColor={"primary"}>{GetField("history")["label"]}</Button></a>
                        </div>}
                    </div>}
                    <div className="row">
                        {columns && permissions && <DataGrid dataSource='apiv7/stock' sortable={false} columns={columns} permissions={permissions} params={site} update={update} subTotals={stockSubTotals} />}
                    </div>
            </ExpansionPanel>}
            {GetField("manageStockpiles")["isVisible"] && <ExpansionPanel title={GetField("manageStockpiles")["label"]} expanded={expandedPanels.manageStockpiles} onToggle={() => togglePanel("manageStockpiles")}>
                    <div className="row" style={{ padding: "5px 10px" }}>
                        <div className="col-md-8" style={{ color: "red" }}>{message}</div>
                    </div>
                    {GetSession().SiteID === 1 && GetField("site")["isVisible"] && <div className="row" style={{ padding: "5px 10px" }}>
                        <div className="col-md-1">
                            <label className="control-label">{GetField("site")["label"]}</label>
                        </div>
                        <div className="col-md-3">
                            <DropDownList data={sites} onChange={siteChanged} textField="name" />
                        </div>
                    </div>}
                    {permissions && permissions.ManageInventory && <div className="row" style={{ padding: "5px 10px" }}>
                        {GetField("add")["isVisible"] && <div className="col-md-2">
                            <Button themeColor={"primary"} onClick={AddStockpile}>{GetField("add")["label"]}</Button>
                        </div>}
                        {GetField("deduct")["isVisible"] && <div className="col-md-2">
                            <Button themeColor={"primary"} onClick={DeductStockpile}>{GetField("deduct")["label"]}</Button>
                        </div>}
                        {GetField("stocktake")["isVisible"] && <div className="col-md-2">
                            <Button themeColor={"primary"} onClick={Stocktake}>{GetField("stocktake")["label"]}</Button>
                        </div>}
                        {GetField("move")["isVisible"] && <div className="col-md-2">
                            <Button themeColor={"primary"} onClick={MoveStockpile}>{GetField("move")["label"]}</Button>
                        </div>}
                        {GetField("convertProduct")["isVisible"] && <div className="col-md-2">
                            <Button themeColor={"primary"} onClick={ConvertProduct}>{GetField("convertProduct")["label"]}</Button>
                        </div>}
                    </div>}
                    <div className="row">
                        {spColumns && permissions && <DataGrid dataSource='apiv7/stockpiles' sortable={false} columns={spColumns} permissions={permissions} params={site} update={update} subTotals={stockSubTotals} />}
                    </div>
            </ExpansionPanel>}
            {dialogTitle !== "" && <Dialog title={dialogTitle} onClose={DialogNo} >
                <div style={{ width: "500px" }}>
                    {showStockpile && <div className="row" style={{ padding: "10px" }}>
                        <div className="col-md-3">
                            <label className="control-label">{GetField("stockpile")["label"]}</label>
                        </div>
                        <div className="col-md-9">
                            <DropDownList data={stockpiles} onChange={sourceChanged} />
                        </div>
                    </div>}
                    {GetField("product")["isVisible"] && <div className="row" style={{ padding: "10px" }}>
                        <div className="col-md-3">
                            <label className="control-label">{GetField("product")["label"]}</label>
                        </div>
                        <div className="col-md-9">
                            <DropDownList data={products} onChange={sourceProductChanged} textField="name" />
                        </div>
                    </div>}
                    {GetField("amount")["isVisible"] && <div className="row" style={{ padding: "10px" }}>
                        <div className="col-md-3">
                            <label className="control-label">{GetField("amount")["label"]}</label>
                        </div>
                        <div className="col-md-9">
                            <NumericTextBox onChange={amountChanged} min={0} />
                        </div>
                    </div>}
                    {(operation === "Move" || operation === "Convert") && GetField("destinationStockpile")["isVisible"] && <div className="row" style={{ padding: "10px" }}>
                        <div className="col-md-3">
                            <label className="control-label">{GetField("destinationStockpile")["label"]}</label>
                        </div>
                        <div className="col-md-9">
                            <DropDownList data={stockpiles} onChange={destChanged} />
                        </div>
                    </div>}
                    {operation === "Convert" && GetField("convertedProduct")["isVisible"] && <div className="row" style={{ padding: "10px" }}>
                        <div className="col-md-3">
                            <label className="control-label">{GetField("convertedProduct")["label"]}</label>
                        </div>
                        <div className="col-md-9">
                            <DropDownList data={products} onChange={destProductChanged} textField="name" />
                        </div>
                    </div>}
                </div>
                <DialogActionsBar ><div style={{ textAlign: "center" }}>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base bigButton acceptButton" onClick={DialogOk}>{dialogTitle}</button>
                </div>
                </DialogActionsBar>
            </Dialog>}
        </div>
    );

}

export default Inventory;